import { DataTableColumn } from 'src/app/shared/components/clickable-row-table/models/data-table-config.models';
import {
  ValueButtonTable,
  ValueDateTable,
  ValuePhoneNumberTable,
  ValueStringTable
} from 'src/app/shared/components/clickable-row-table/models/value-table.model';
import { sort } from 'src/app/shared/helpers/table.constants';

export interface AppRequestsTableRows {
  id: ValueStringTable;
  fullName: ValueStringTable;
  email: ValueStringTable;
  phone: ValueStringTable;
  timestamp: ValueDateTable | ValueStringTable;
  delete: ValueButtonTable;
  isSelected?: boolean;
}

export class AppRequestsTableColumns {
  // prettier-ignore
  public static columns: DataTableColumn[] = [
    { name: { key: 'user.nameSurname' }, value: 'fullName'  },
    { name: { key: 'label.email'      }, value: 'email'     },
    { name: { key: 'label.phone'      }, value: 'phone'     },
    { name: { key: 'rUser.demandDate' }, value: 'timestamp' },
    { name: { key: ''                 }, value: 'delete'    }
  ];
}

export interface BulkInvitesTableRows {
  id: ValueStringTable;
  fullName: ValueStringTable;
  phone: ValuePhoneNumberTable;
  checked: boolean;
  invited: boolean;
}

export class BulkInvitesTableColumns {
  // prettier-ignore
  public static columns: DataTableColumn[] = [
    { name: { key: ''                 }, value: 'id'             },
    { name: { key: 'user.nameSurname' }, value: 'fullName', sort },
    { name: { key: 'label.phone'      }, value: 'phone',    sort }
  ];
}
